import { authorityPhrases } from "@/mocks/llkContent";
import { ScrollReveal } from "@/components/animations/ScrollReveal";
import { StaggerContainer, StaggerItem } from "@/components/animations/StaggerContainer";

export default function AuthoritySection() {
  return (
    <section className="relative py-20 md:py-28 bg-llk-dark">
      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
        <ScrollReveal>
          <p className="text-xs md:text-sm font-semibold tracking-[0.2em] uppercase text-llk-gold mb-6">
            PRINCÍPIO TÉCNICO
          </p>
        </ScrollReveal>

        <ScrollReveal delay={0.1}>
          <h2 className="font-display text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-white font-semibold mb-12 md:mb-16">
            Biotecnologia aplicada ao agronegócio de alta performance
          </h2>
        </ScrollReveal>

        <StaggerContainer className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8" staggerDelay={0.12} delayChildren={0.2}>
          {authorityPhrases.map((phrase, idx) => (
            <StaggerItem key={idx}>
              <div className="relative p-6 md:p-8 rounded-2xl bg-llk-dark-2 border border-white/10 transition-all duration-500 hover:border-llk-gold/30 h-full">
                <div className="w-10 h-10 rounded-full bg-llk-gold/10 flex items-center justify-center mb-4">
                  <i className="ri-check-double-line text-llk-gold text-lg" />
                </div>
                <p className="text-white/90 text-lg md:text-xl font-semibold leading-snug">
                  {phrase}
                </p>
              </div>
            </StaggerItem>
          ))}
        </StaggerContainer>
      </div>
    </section>
  );
}